<template>
  <b-container>
    <b-form
      v-if="userProfile"
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="メールアドレス"
          >
            <b>{{ userProfile.email }}</b>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="名"
            label-for="firstname"
          >
            <b-form-input
              id="firstname"
              name="firstName"
              :value="firstName"
              type="text"
              required
              placeholder="花子"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="性"
            label-for="lastname"
          >
            <b-form-input
              id="lastname"
              name="lastName"
              :value="lastName"
              type="text"
              placeholder="虹村"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!--<b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="団体名（任意）"
            label-for="company"
          >
            <b-form-input
              id="company"
              :value="company"
              type="text"
              placeholder="虹の会"
            />
          </b-form-group>
        </b-col>
      </b-row>-->

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="パスワード"
          >
            <span class="password">**********</span>
            <b-link
              :to="{ name: 'edit-password' }"
              class="ml-2"
            >
              パスワードを変更
            </b-link>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="submit"
              block
              variant="primary"
            >
              <b-icon
                v-if="userProfileStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>アカウントを更新する</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {USER_UPDATE} from "@/store/constant";

export default {
  name: 'Account',
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
      }
    }
  },
  computed: {
    firstName: {
      get() {
        return this.userProfile ?this.userProfile.firstName :null
      }
    },
    lastName: {
      get() {
        return this.userProfile ?this.userProfile.lastName :null
      }
    },
    // company: {
    //   get() {
    //     return this.userProfile ?this.userProfile.company :null
    //   }
    // },
    ...mapGetters(['userProfile', 'userProfileStatus'])
  },
  methods: {
    onSubmit(e) {
      const formData = {
        firstName: e.target.firstName.value,
        lastName: e.target.lastName.value,
      }
      this.$store.dispatch(USER_UPDATE, formData)
    },
  }
}
</script>

<style scoped lang="less">
.password {
  display: inline-block;
  vertical-align: sub;
}
</style>
